import React from 'react'
import { useSelector } from 'react-redux'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { Utils } from 'src/functions/utils'
import { ws } from 'src/functions/ws'
import { IState } from 'src/models/state'

export const FeesMain = () => {

	const tradeFees = useSelector((state: IState) => state.tradeFees)
	const withdrawFees = useSelector((state: IState) => state.withdrawFees)

	const today = new Date().toJSON().split('T')[0]
	const [period, setPeriod] = React.useState({
		initialPeriod: new Date(today + ' 00:00:00'),
		finalPeriod: new Date(today + ' 23:59:59.999')
	})

	React.useEffect(
		() => {
			ws.send({ type: 'TradeFees.Get', period } as any)
			ws.send({ type: 'WithdrawFees.Get', period } as any)

		},
		[])

	const filterTradesPeriod = () => {
		ws.send({ type: 'TradeFees.Get', period } as any)
	}
	const filterWithdrawalsPeriod = () => {
		ws.send({ type: 'WithdrawFees.Get', period } as any)
	}

	return (
		<div className='orderbooksMain'>
			<span className='pageTitle'>Fees</span>
			<Tabs>
				<TabList>
					<Tab>Trades</Tab>
					<Tab>Withdrawals</Tab>
				</TabList>
				<TabPanel>
					<span className='pageBoxTitle'>Period:</span>
					<div className='filterPeriod'>

						<label htmlFor='initialPeriod' >Initial:</label>
						<input name='initialPeriod' type='date' onChange={(e) => setPeriod({ ...period, initialPeriod: new Date(e.target.value + ' 00:00:00') })} defaultValue={today} />

						<label htmlFor='finalPeriod' >Final:</label>
						<input name='finalPeriod' type='date' onChange={(e) => setPeriod({ ...period, finalPeriod: new Date(e.target.value + ' 23:59:59.999') })} defaultValue={today} />

						<button name='filterPeriod' className='walletsTableButton' onClick={filterTradesPeriod}>Filter</button>

					</div>
					<br />
					<div>
						<table className='withdrawsTableMain'>
							<thead>
								<tr className='withdrawsTableHeaderRow'>
									<td className='withdrawsTableHeaderRowItem'>Date</td>
									<td className='withdrawsTableHeaderRowItem'>Amount</td>
									<td className='withdrawsTableHeaderRowItem'>Coin</td>
									<td className='withdrawsTableHeaderRowItem'>Trade ID</td>
									<td className='withdrawsTableHeaderRowItem'>Tax ID Type</td>
									<td className='withdrawsTableHeaderRowItem'>Tax ID Number</td>
								</tr>
							</thead>
							<tbody>
								{tradeFees.map(m => 
									<tr className='withdrawsTableBodyRow' key={`${m.tradeId}${m.currency}`}>
										<td className='withdrawsTableBodyRowItem'>{m.date ? new Date(m.date).toLocaleString('en-GB') : ''}</td>
										<td className='withdrawsTableBodyRowItem'>{m.fee.toFixed(8)}</td>
										<td className='withdrawsTableBodyRowItem'>{m.currency}</td>
										<td className='withdrawsTableBodyRowItem'>{Utils.pad(Utils.base32.encode(m.tradeId), 6)}</td>
										<td className='withdrawsTableBodyRowItem'>{m.docTypeId}</td>
									<td className='withdrawsTableBodyRowItem'>{m.docIdNumber}</td>
								</tr>
								)}
							</tbody>
						</table>
					</div>
				</TabPanel>
				<TabPanel>
					<span className='pageBoxTitle'>Period:</span>
					<div className='filterPeriod'>

						<label htmlFor='initialPeriod' >Initial:</label>
						<input name='initialPeriod' type='date' onChange={(e) => setPeriod({ ...period, initialPeriod: new Date(e.target.value + ' 00:00:00') })} defaultValue={today} />

						<label htmlFor='finalPeriod' >Final:</label>
						<input name='finalPeriod' type='date' onChange={(e) => setPeriod({ ...period, finalPeriod: new Date(e.target.value + ' 23:59:59.999') })} defaultValue={today} />

						<button name='filterPeriod' className='walletsTableButton' onClick={filterWithdrawalsPeriod}>Filter</button>

					</div>
					<br />
					<div>
						<table className='withdrawsTableMain'>
							<thead>
								<tr className='withdrawsTableHeaderRow'>
									<td className='withdrawsTableHeaderRowItem'>Date</td>
									<td className='withdrawsTableHeaderRowItem'>Amount</td>
									<td className='withdrawsTableHeaderRowItem'>Coin</td>
									<td className='withdrawsTableHeaderRowItem'>Withdraw ID</td>
									<td className='withdrawsTableHeaderRowItem'>Tax ID Type</td>
									<td className='withdrawsTableHeaderRowItem'>Tax ID Number</td>
								</tr>
							</thead>
							<tbody>
								{withdrawFees.map(m =>
									<tr className='withdrawsTableBodyRow' key={m.withdrawId}>
										<td className='withdrawsTableBodyRowItem'>{m.date ? new Date(m.date).toLocaleString('en-GB') : ''}</td>
										<td className='withdrawsTableBodyRowItem'>{m.fee.toFixed(8)}</td>
										<td className='withdrawsTableBodyRowItem'>{m.currency}</td>
										<td className='withdrawsTableBodyRowItem'>{Utils.pad(Utils.base32.encode(m.withdrawId), 6)}</td>
										<td className='withdrawsTableBodyRowItem'>{m.docTypeId}</td>
										<td className='withdrawsTableBodyRowItem'>{m.docIdNumber}</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</TabPanel>
			</Tabs>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/feesMain.tsx